import { defineMessages } from 'react-intl';

export default defineMessages({
  dashboard: 'Dashboard',
  userData: 'Powiedz coś o sobie',
});
